export var canUseDom = function canUseDom() {
  var _window, _window$document;
  return !!(typeof window !== 'undefined' && (_window = window) !== null && _window !== void 0 && (_window$document = _window.document) !== null && _window$document !== void 0 && _window$document.createElement);
};